/**
 * @override
 * Same as Contentful FullHeaderFragment but uses king-living BaseHeaderFragment (includes searchIdle).
 */

import gql from 'graphql-tag';

import {BaseHeaderFragment} from '@amblique/king-living/app/contentful/fragments/header/base-header.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {NavigationMenuFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu/navigation-menu.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {SectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/section-panel.fragment';

export const FullHeaderFragment = gql`
  ${BaseHeaderFragment}
  ${ImageFragment}
  ${LinkFragment}
  ${NavigationMenuFragment}
  ${RichTextBlockFragment}
  ${SectionPanelFragment}

  fragment FullHeaderFragment on Header {
    ...BaseHeaderFragment

    logo {
      ...ImageFragment
    }
    mainNavigation {
      ...NavigationMenuFragment
    }
    promoBannersCollection {
      items {
        __typename
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
      }
    }
    promoBannersCursorCollection {
      items {
        __typename
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
      }
    }
    utilityLinksCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    utilityLinksCursorCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
  }
`;
